import { useSelector, shallowEqual } from 'react-redux'

import { DetailsGroup, useReportDetailsGroup } from './useReportDetailsGroup'
import { Allowance } from './useReportAllowances'


export type AllSchoolsAllowancesAndFoodModesDto = Array<{
  school_title: string
  data: {
    personal: number
    common: number
    total: number
    allowances: Record<Allowance, {
      Завтрак: number
      Обед: number
      Полдник: number
    }>
  }
}>

export function useReportAllSchoolsAllowancesAndFoodModesDto() {
  const allSchools = useSelector((state: any) => state.reports.subsidies.data.all_schools, shallowEqual)
  const detailsGroup = useReportDetailsGroup()

  if (allSchools && detailsGroup === DetailsGroup.ByAllowancesAndFoodModes) {
    return allSchools as AllSchoolsAllowancesAndFoodModesDto
  }
  return null
}
